import { ref } from "vue";
function useVModelToggleList() {
  const activeComponentIndex = ref(null);
  function changeActiveComponent(value, index) {
    activeComponentIndex.value = value ? index : null;
  }
  function componentState(index) {
    return activeComponentIndex.value === index;
  }
  return function(index) {
    return {
      modelValue: componentState(index),
      "onUpdate:modelValue": (value) => changeActiveComponent(value, index)
    };
  };
}
export {
  useVModelToggleList
};
